import "./index.less";
import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import ShopType from "@/enum/ShopType";
import { useGlobalStore } from "@/store/hooks";
import { observer } from "mobx-react-lite";
import { PlusOutlined } from "@ant-design/icons";
import ShopItem from "./ShopItem";
import AllShopItem from "./AllShopItem";
import { TbGroupShopTypes } from "@/utils/ShopUtils";
import CreateManualShopButton from "./CreateManualShopButton";

interface ShopSelectProps {
    shopId?: number;
}

const ShopSelect: React.FC<ShopSelectProps> = function (props) {
    const { shopId: currentShopId } = props;

    const { allowedShops: shops, shopMapping, currentUser, setShowDecryptMenu, companyRoleStore } = useGlobalStore();

    const userShopType = shopMapping.get(currentUser?.shopId)?.type;

    const isTBUser = TbGroupShopTypes.includes(userShopType);

    useEffect(() => {
        const currentShopType = shopMapping.get(currentShopId)?.type;

        if (currentShopType === ShopType.PINDUODUO) {
            setShowDecryptMenu(true);
        } else {
            setShowDecryptMenu(false);
        }

        return () => {
            setShowDecryptMenu(false);
        };
    }, [currentShopId]);

    if (!shops?.length) {
        return <div className="shop-select">加载中...</div>;
    }

    return (
        <div className="shop-select">
            <span className="shop-select-title">选择店铺 </span>
            <div className="small">
                <span>共{shops.length}个店铺</span>
                <Link to="/setting/shop?index_tip=1" className="ml3">
                    排序
                </Link>
            </div>

            <div className="nav flex-column nav-pills">
                <AllShopItem />

                <>
                    {shops?.map?.((shop) => (
                        <ShopItem key={shop.id} shop={shop} currentShopId={currentShopId} isTBUser={isTBUser} />
                    ))}
                </>

                <CreateManualShopButton />
            </div>

            {!companyRoleStore.isPureSupplier ? (
                <Link to="/setting/shop/add">
                    <PlusOutlined className="mr3" />
                    <span>添加店铺</span>
                </Link>
            ) : null}

            <hr />
        </div>
    );
};

export default observer(ShopSelect);
